import { isPositiveInt } from "./is";
import { isNil } from "./type-guards/nil";

export function parsePositiveIntParam(
  raw: string | number | null | undefined,
): number | undefined {
  if (isNil(raw) || raw === "") return undefined;

  const n = Number(raw);

  return isPositiveInt(n) ? n : undefined;
}
